import { solutionMapping } from '../../services/timeline-service';

class NeonatalTpnUtils {

  public static getSolutionTypeByItemType(itemType: string): number {
    const ZERO_VALUE = 0;
    return solutionMapping[itemType] || ZERO_VALUE;
  }
}

export default NeonatalTpnUtils;